import { LoadingCss, SpinnerCss } from "@/App/style";
import { Spin } from "antd";
import axios from "axios";
import { useEffect } from "react";

const showLoading = (show: boolean) => {
  const loader = document.querySelector("#loader") as HTMLElement;
  loader.style.display = show ? "block" : "none";
};

const addInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      showLoading(true);
      return config;
    },
    (error) => {
      showLoading(false);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      showLoading(false);
      return response;
    },
    (error) => {
      showLoading(false);
      return Promise.reject(error);
    }
  );
};

export const SpinLoader = ({ text }: { text: string }) => {
  useEffect(addInterceptors, []);

  return (
    <div id="loader" style={{ display: "none" }}>
      <LoadingCss>
        <SpinnerCss>
          <Spin size="large" />
          <h2>{text}</h2>
        </SpinnerCss>
      </LoadingCss>
    </div>
  );
};
